module.exports = __webpack_public_path__ + "img/hz1.e199085b.png";